import { Card, CardBody, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import {
  FaChartArea,
  FaDatabase,
  FaFileExcel,
  FaLightbulb,
  FaRobot,
} from "react-icons/fa";

export default function NoContentCard({ t }) {
  return (
    <Card shadow="md">
      <CardBody>
        <VStack spacing={1} py={1} textAlign="center">
          <Icon as={FaChartArea} fontSize="xl" color="gray.300" />
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            {t(
              "reports.selectReportInstructions",
              "اختر نوع التقرير واضبط الفلاتر"
            )}
          </Text>
          <Text fontSize="sm" color="gray.400" maxW="md">
            {t(
              "reports.runAnalysisInstructions",
              'اضغط على "تحليل ذكي مع AI" للحصول على تقرير متكامل'
            )}
          </Text>
          <VStack spacing={1} align="center" mt={1}>
            <HStack spacing={1}>
              <Icon as={FaRobot} color="green.500" />
              <Text fontSize="sm" color="gray.600">
                {t("reports.smartAnalysisWithAI", "تحليل ذكي مع AI")}
              </Text>
            </HStack>
            <HStack spacing={1}>
              <Icon as={FaDatabase} color="blue.500" />
              <Text fontSize="sm" color="gray.600">
                {t("reports.originalAPIData", "بيانات API أصلية")}
              </Text>
            </HStack>
            <HStack spacing={1}>
              <Icon as={FaFileExcel} color="yellow.500" />
              <Text fontSize="sm" color="gray.600">
                {t("reports.excelUpload", "رفع ملفات Excel")}
              </Text>
            </HStack>
            <HStack spacing={1}>
              <Icon as={FaLightbulb} color="purple.500" />
              <Text fontSize="sm" color="gray.600">
                {t("reports.practicalRecommendations", "توصيات عملية")}
              </Text>
            </HStack>
          </VStack>
        </VStack>
      </CardBody>
    </Card>
  );
}
